import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {UserService} from "../../_services/user.service";
import {Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthenticationService} from "../../_services/authentication.service";
import {CustomsValidationDirective} from "../../_directives/customs-validation.directive";
import {DialogService} from 'ng2-bootstrap-modal';
import {ShowModulesComponent} from './show-modules/show-modules.component';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit {
    returnUrl: any = '/login';
    registerForm: FormGroup;
    msgErrUserName: any = null;
    msgErrEmail: any = null;
    msgErrPassConfirm: any = false;
    loading = false;
    public msgError: any = null;
    modulesAlls: any = [];
    modules: any;
    constructor(private userService: UserService,
                private router: Router, f: FormBuilder,
                private authenticationService: AuthenticationService,
                private dialogService: DialogService) {

        this.registerForm = f.group({
            username: new FormControl('', [Validators.required, Validators.minLength(5),
                Validators.maxLength(15), Validators.pattern("[a-z0-9_]{5,15}$")]),
            displayName: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required, this.noWhitespaceValidator, Validators.minLength(6)]),
            passConfirm: new FormControl('', [Validators.required]),
            modules: new FormControl('', [Validators.required])
        }, {
            validator: CustomsValidationDirective.MatchPassword
        });
    }

    ngOnInit() {
        this.userService.getAllModules().subscribe(res => {
            this.modulesAlls = res;
            this.modules = res[0].id;
        });
        this.isLogin();
    }

    isLogin() {
        var currentUser = this.authenticationService.getCurrentUser();
        if (currentUser != null) {
            currentUser.subscribe(data => {
                this.router.navigate(["/admin"]);
            });
        }
    }

    onRegister() {
        let self = this;
        if (this.registerForm.valid) {
            self.loading = true;
            self.userService.register(self.registerForm.value)
                .subscribe(data => {
                        self.router.navigate([self.returnUrl]);
                    }, error => {
                        self.loading = false;
                        try {
                            let resData = JSON.parse(error._body);
                            if (resData.hasOwnProperty('result') && resData.result == false) {
                                if (resData.hasOwnProperty('type') && resData.type === '_VALIDATE_') {
                                    self.msgErrEmail = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('email')) ? resData.error.email[0] : null;
                                    self.msgErrUserName = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('username')) ? resData.error.username[0] : null;
                                    self.msgErrPassConfirm = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('passConfirm')) ? true : false;
                                } else if (resData.hasOwnProperty('type') && resData.type === '_FAIL_'){
                                    self.msgError = resData.hasOwnProperty('error') ? resData.error : null;
                                }
                            }
                        } catch (e) {
                            console.log('error', error);
                        }
                    }
                );
        } else {
            CustomsValidationDirective.validateAllFormFields(self.registerForm);
        }
    }

    isFieldValid(field: string) {
        return !this.registerForm.get(field).valid && this.registerForm.get(field).touched;
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
            'has-feedback': this.isFieldValid(field)
        };
    }

    noWhitespaceValidator(control: FormControl) {
        return (control.value || '').indexOf(' ') >= 0 ? { 'whitespace': true } : null;
    }

    onFocusout(field: string, event) {
        let self = this;
        self.msgErrUserName = self.msgErrEmail = self.msgError = null;
        self.msgErrPassConfirm = false;
    }

    openModalAddMail() {
        let self = this;
        this.dialogService.addDialog(ShowModulesComponent);
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/register/register.component.ts